module.exports = __webpack_public_path__ + "media/images/logos/atos-8c23e6a5bb08e1f2a7da779bfdbe0221.png";